import React, { useState } from 'react';
import { styled } from '../../../../../shared/Theme/theme';
import { document } from '../../../../../../models/entities/businessPartner/document';
import Loader from '../../../../../shared/SmallComponents/Loader';
import { ColumnType } from '../../../../../shared/Grid/types/Column';
import Grid from '../../../../../shared/Grid/Grid';
import CustomModal, { ModalTriggerProps } from '../../../../../shared/Modal/Modal';
import DocumentFormConnected, { formMode } from '../../DocumentForm/DocumentFormConnected';
import Button from '../../../../../shared/SmallComponents/Button';
import attachment from '../../../../../../static/icons/attachment.svg';
import { settings } from '../../../../../../models/entities/businessPartner/businessPartner';
import MultipleDocumentFormConnected from '../../DocumentForm/MultipleDocumentFormConnected';

type Props = {
    documents?: Array<document>;
    localization: any;
    settings?: settings;
};

const BusinessPartnersDocuments = ({ documents, localization, settings }: Props) => {
    const { type, name, date, added_by, comment } = localization.documents.grid.columns;
    const gridColumns: Array<ColumnType<document>> = [
        {
            title: type,
            field: 'type',
            sortable: false,
            isDisplayed: true,
            columnType: 'document_type',
            bindedFields: ['type']
        },
        {
            title: name,
            field: 'fileName',
            sortable: false,
            isDisplayed: true,
            columnType: 'fileExtIcon',
            bindedFields: ['fileId', 'fileName']
        },
        {
            title: date,
            field: 'createdDate',
            sortable: false,
            isDisplayed: true,
            columnType: 'date'
        },
        {
            title: added_by,
            field: 'userName',
            sortable: false,
            isDisplayed: true
        },
        {
            title: comment,
            field: 'comment',
            sortable: false,
            isDisplayed: true
        }
    ];

    const [modalVisible, setVisible] = useState(false);
    const [document, setDocument] = useState({} as document);
    const [addModalVisible, setAddModalVisible] = useState(false);
    
    return (
        <DocumentsWrapper>
            {documents ? (
                <>
                    <CustomModal
                        isOpen={addModalVisible}
                        title={{ icon: attachment, text: localization.documents.modal.add_title }}
                        Trigger={(props: ModalTriggerProps) => (
                            <ButtonContainer>
                                <Button onClick={() => setAddModalVisible(true)} width="auto" buttonType="hollow" padding="4px 12px">
                                    {localization.documents.add_document}
                                </Button>
                            </ButtonContainer>
                        )}
                        Content={(
                            setVisible?: React.Dispatch<React.SetStateAction<boolean>>,
                            setConfirm?: React.Dispatch<React.SetStateAction<boolean>>
                        ) => {
                            return (
                                <MultipleDocumentFormConnected
                                    mode={formMode.NEW}
                                    openedFromModal={setVisible ? { setVisible } : undefined}
                                    confirmation={setConfirm ? { setConfirm } : undefined}
                                />
                            );
                        }}
                        width="500px"
                        onCancelCallback={() => setAddModalVisible(false)}
                    />
                    {documents.length > 0 ? (
                        <GridWrapper>
                            <Grid<document>
                                columns={gridColumns}
                                data={documents}
                                localization={localization.documents.grid}
                                settings={settings}
                                onSettingsClick={() => console.log('settings')}
                                onRowMoreOptionsClick={(row) => {
                                    setDocument(row);
                                    setVisible(true);
                                }}
                                menuType="businessPartnerDocumentMenu"
                            />
                            {modalVisible && (
                                <CustomModal
                                    title={{ icon: attachment, text: localization.documents.modal.edit_title }}
                                    isOpen={true}
                                    Content={(
                                        setModalVisible?: React.Dispatch<React.SetStateAction<boolean>>,
                                        setConfirm?: React.Dispatch<React.SetStateAction<boolean>>
                                    ) => {
                                        return (
                                            <DocumentFormConnected
                                                mode={formMode.EDIT}
                                                document={document}
                                                openedFromModal={{ setVisible }}
                                                confirmation={setConfirm ? { setConfirm } : undefined}
                                            />
                                        );
                                    }}
                                    onCancelCallback={() => {
                                        setVisible(false);
                                        setDocument({} as document);
                                    }}
                                    width="393px"
                                />
                            )}
                        </GridWrapper>
                    ) : (
                        <EmaptyStateText>{localization.documents.empty_state}</EmaptyStateText>
                    )}
                </>
            ) : (
                <Loader />
            )}
        </DocumentsWrapper>
    );
};

const GridWrapper = styled.div`
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-y: overlay;
    height: 100%;
    width: 100%;
`;

const DocumentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const EmaptyStateText = styled.span`
    color: ${(props) => props.theme.colors.emptyStateText};
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
`;

export default BusinessPartnersDocuments;
